import { useCallback, useRef } from "react";
import { useSaveSelfEvalutionFormInfomationByPeerReviewerMutation } from "../../../../../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import ToastService from "../../../../../../services/toastService/ToastService";
import { ACTIONS, useSelfEvaluationInfoContext } from "../Form/SelfEvaluationInfoContext";

export function useRequirementComment() {
    const { state, dispatch } = useSelfEvaluationInfoContext();
    const [saveComment, { isLoading, originalArgs }] = useSaveSelfEvalutionFormInfomationByPeerReviewerMutation();

    const requirementsRef = useRef(state.requirements);
    requirementsRef.current = state.requirements;

    const changeComment = useCallback(
        (reqId, value) => dispatch({ type: ACTIONS.SET_PEER_COMMENT, reqId, value }),
        [dispatch]
    );

    const saveRequirementComment = useCallback(
        async (reqId) => {
            const req = requirementsRef.current[reqId];
            if (!req?.selfEvalRequirementId) return;
            try {
                const res = await saveComment({
                    SelfEvaluationRequirementId: req.selfEvalRequirementId,
                    PeerReviewerComment: req.peerReviewerComments,
                }).unwrap();
                if (res?.hasError) ToastService.error(res.errorMessage);
                else ToastService.success("Peer Reviewer Comment Save");
            } catch {
                ToastService.error("Unable to save comment.");
            }
        },
        [saveComment]
    );

    const savingSelfEvalRequirementId = isLoading ? originalArgs?.SelfEvaluationRequirementId : null;
    return { changeComment, saveRequirementComment, savingSelfEvalRequirementId };
}